/*
 * UNIK focus mode (F6-03): focus rings show for keyboard navigation only. Tab and the other
 * navigation keys set data-unik-focus="keyboard" on <html>; a mouse, touch or pen press
 * removes it. Once this script has set data-unik-focus-mode, unik-base.css hides the rings
 * without data-unik-focus, also when a script moves focus
 * (autofocus, drawers, Colorblock's re-rendered variant picker), which browsers' own
 * :focus-visible shows in Safari and for every focused text field.
 */
(() => {
  if (document.documentElement.hasAttribute('data-unik-focus-mode')) return;
  document.documentElement.setAttribute('data-unik-focus-mode', '');

  const NAVIGATION_KEYS = new Set([
    'Tab', 'Enter', ' ', 'Escape', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight',
    'Home', 'End', 'PageUp', 'PageDown',
  ]);
  const TEXT_ENTRY = 'textarea, select, input:not([type="checkbox"], [type="radio"], [type="button"], [type="submit"], [type="reset"], [type="range"], [type="color"], [type="file"], [type="image"])';

  // Typing in a field (space, arrows, Enter) is not navigation; Tab and Escape leave it.
  const isNavigation = (event) => {
    if (event.metaKey || event.ctrlKey || event.altKey || !NAVIGATION_KEYS.has(event.key)) return false;
    if (event.key === 'Tab' || event.key === 'Escape') return true;
    const target = event.target;
    return !(target instanceof Element && (target.matches(TEXT_ENTRY) || target.isContentEditable));
  };

  document.addEventListener('keydown', (event) => {
    if (isNavigation(event)) document.documentElement.dataset.unikFocus = 'keyboard';
  }, true);
  document.addEventListener('pointerdown', () => {
    delete document.documentElement.dataset.unikFocus;
  }, true);
})();
